import React from "react";
import phone2 from "../../assets/img/phone_1.jpeg";
import phone1 from "../../assets/img/phone_2.jpeg";
import { useTranslation } from "react-i18next";

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section id="hero" className="hero section dark-background">
      <div className="container">
        <div className="row gy-4">
          {/* TEXTUL – apare primul pe mobil, stânga pe desktop */}
          <div
            className="col-lg-8 d-flex flex-column justify-content-center align-items text-center text-md-start order-1 order-lg-1"
            data-aos="fade-up"
          >
            <h2>{t("hero.title")}</h2>
            <p>{t("hero.subtitle")}</p>
            <div className="d-flex mt-4 justify-content-center justify-content-md-start">
              <a href="#contact" className="download-btn">
                <i className="bi bi-send"></i> <span>{t("hero.cta")}</span>
              </a>
            </div>
          </div>

          {/* IMAGINILE – apar jos pe mobil, dreapta pe desktop */}
          <div
            className="col-lg-4 hero-img order-2 order-lg-2 image-left-mobile"
            data-aos="zoom-out"
          >
            <img src={phone1} alt="Phone 1" className="phone-1" />
            <img src={phone2} alt="Phone 2" className="phone-2" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
